import { StyledIcon, StyledInner, StyledText, StyledChipButton } from "./chip.style";
import { IMDSChipProps } from "./chip.types";

export const MDSChip = (props: IMDSChipProps) => {
  const { iconKind, children, maxWidth, color = "default", ...rest } = props;

  return (
    <StyledChipButton $color={color} {...rest}>
      <StyledInner maxWidth={maxWidth}>
        <StyledIcon kind={iconKind} />
        <StyledText>{children}</StyledText>
      </StyledInner>
    </StyledChipButton>
  );
};
